import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface CountryInput {
  id?: GQL_ID
  name: string
  ISO2: string
  ISO3: string
  web_domain?: string
  iso_numeric?: number
  phone_code?: number
  currency_name?: string
  currency_symbol?: string
  language_codes?: string
}

export interface Country {
  id: GQL_ID
  name: string
  ISO2: string
  ISO3: string
  web_domain?: string
  iso_numeric?: number
  phone_code?: number
  currency_name?: string
  currency_symbol?: string
  language_codes?: string
}

export interface SaveCountryMutation {
  saveCountry: Country
}

export interface SaveCountryVariables {
  countryInput: CountryInput
  upsert?: boolean
}

export const GQL_MUTATION_SAVE_COUNTRY = gql`
  mutation saveCountry($countryInput: CountryInput!, $upsert: Boolean) {
    saveCountry(countryInput: $countryInput, upsert: $upsert) {
      id
      name
      ISO2
      ISO3
      web_domain
      iso_numeric
      phone_code
      currency_name
      currency_symbol
      language_codes
    }
  }
`

export const useSaveCountry = () =>
  useMutation<SaveCountryMutation, SaveCountryVariables>(GQL_MUTATION_SAVE_COUNTRY)
